import React from "react";

import styled from "styled-components";
import { Colors } from "../../config/Constants";
import Icon from "./Icon";

type SideBarItemProps = {
  onRoute: (route: string) => void;
  activePath: string;
  route: {
    label: string;
    path: string;
  };
};

const SidebarItem = ({ onRoute, activePath, route }: SideBarItemProps) => {
  return (
    <StyledSidebarItemComponent
      onClick={() => onRoute(route.path)}
      className={activePath === route.path ? "active" : ""}
    >
      <Icon isActivePath={activePath === route.path} path={route.path} />
      <span>{route.label}</span>
    </StyledSidebarItemComponent>
  );
};

const StyledSidebarItemComponent = styled.li`
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  position: relative;
  font-size: 0.875rem;
  font-family: Poppins-Medium;
  display: flex;
  align-items: center;
  &.active::before,
  &.active::after {
    content: "";
    position: absolute;
  }
  &.active {
    background: white;
    border-radius: 1.5rem 0 0 1.5rem;
  }
  > span {
    padding: 0 8px;
    padding-left: 1rem;
    color: white;
    text-decoration: none;
    line-height: 1rem;
    @media only screen and (max-width: 1200px) {
      display: none;
    }
  }
  &.active > span {
    color: ${Colors.red};
    @media only screen and (max-width: 1200px) {
      display: none;
    }
  }
  &.active::before {
    top: -2.5rem;
    right: 0px;
    height: 2.5rem;
    width: 1.25rem;
    border-bottom-right-radius: 2.5rem;
    box-shadow: 0 1.25rem 0 0 white;
  }
  &.active::after {
    top: 2.5rem;
    right: 0px;
    height: 2.5rem;
    width: 1.25rem;
    border-top-right-radius: 2.5rem;
    box-shadow: 0 -1.25rem 0 0 white;
  }
`;

export default SidebarItem;
